var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkyscraper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 18 16",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 6v-3 .00002254c.0001431-.41421375.3360457-.74988375.7502625-.7497413.0898065 0 .1788765.01619105.2629702.04771055l3.75 1.40625v-.00000001c.2929478.1098015.4869668.3899085.4867712.70275825v11.34299997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.9 5.99999986h4.2c.4970565 0 .9.40294364.9.90000014v8.85h-6.00000004v-8.85-.00000014c0-.4970565.4029435-.9.9-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.24999997 6v-1.5c0-.41421375-.33578622-.75-.74999997-.75h-3-.00000003c-.41421375 0-.75.33578625-.75.75v3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 2.25v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 15.75h-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.875 10.275h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.875 8.25h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.875 12.3h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.25 15.7500001v-6.7500001.00000011c0-.41421375.33578625-.75.75-.75h3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyscraper);
export default __webpack_public_path__ + "static/media/skyscraper.657b899fcf81622b968f4ad1bb99fbbb.svg";
export { ForwardRef as ReactComponent };